import { render, staticRenderFns } from "./QuestionBrowsing.vue?vue&type=template&id=b5349dd8&scoped=true"
import script from "./QuestionBrowsing.vue?vue&type=script&lang=js"
export * from "./QuestionBrowsing.vue?vue&type=script&lang=js"
import style0 from "./QuestionBrowsing.vue?vue&type=style&index=0&id=b5349dd8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5349dd8",
  null
  
)

export default component.exports